import { useContext } from "react";
import { useLocation, useMatch } from "react-router-dom";
import { BreadcrumbProps } from "./types";
import { RoomsRealtimeContext } from "../../Layout/context";

/* **
 * Used to populate the breadcrumbs' status through contextual informations
 * These are used as "default" value when no props are passed to the component
 * If props are passed to the component, they will be prioritised over the ones given by this hook
 * **/
export const useBreadcrumb = () => {
  const roomDetailsMatch = useMatch("assets/rooms/:roomid");
  const deviceDetailsMatch = useMatch("assets/devices/:deviceid");
  const meetingDetailsMatch = useMatch("meetings/:meetingid");
  const location = useLocation();
  const state =
    (location.state as { previous?: string; current?: string }) ?? {};
  const context = useContext(RoomsRealtimeContext);

  let props: BreadcrumbProps = {};
  // Case Device
  if (
    deviceDetailsMatch !== null &&
    deviceDetailsMatch.params.deviceid !== undefined
  ) {
    props.title = context.detail?.device?.name;
    props.componentId = context.detail?.device?.id;
    // Case Room
  } else if (
    roomDetailsMatch !== null &&
    roomDetailsMatch.params.roomid !== undefined
  ) {
    props.title = context.detail?.room?.name;
    props.componentId = context.detail?.room?.id;
    // Case Meeting
  } else if (
    meetingDetailsMatch !== null &&
    meetingDetailsMatch.params.meetingid !== undefined
  ) {
    props.title = `${context.detail?.meeting?.meetingId ?? ""}`;
    props.componentId = `${context.detail?.meeting?.id}`;
    // Case Location
  } else {
    props.title = state.current;
  }

  return props;
};
